import { isValidElement, type ReactNode } from "react";

/**
 * The visible text of a React subtree. Renderers that receive already-built children — a
 * Markdown `a` or `code` component, for instance — need the words back as a string to label
 * a chip or hand a code block to a highlighter, and the children can be nested elements
 * rather than a bare string.
 */
export function flattenReactNodeText(value: ReactNode): string {
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (Array.isArray(value)) {
    return value.map((entry) => flattenReactNodeText(entry)).join("");
  }

  if (isValidElement(value)) {
    return flattenReactNodeText((value.props as { children?: ReactNode }).children);
  }

  return "";
}
